import { HorizontalBar } from 'vue-chartjs'

export default {
	extends: HorizontalBar,
	props: ['orderField', 'sort', 'companies', 'categories', 'salesChannel', 'date', 'subcat'],
	data () {
		return {
			dataset: {},
			isRendered: false
		}
	},
	computed: {
		chartData () {
			return this.dataset
		},
		options () {
			return {
				scales: {
					yAxes: [{
						scaleLabel: {
							display: true,
							labelString: 'Kategorie'
						},
						ticks: {
							beginAtZero: true
						},
						gridLines: {
							display: true
						}
					}],
					xAxes: [{
						ticks: {
							beginAtZero: true
						},
						gridLines: {
							display: false
						}
					}]
				},
				legend: {
					display: true
				},
				responsive: true,
				maintainAspectRatio: true
			}
		}
	},
	methods: {
		getData () {
			this.$emit('loading')
			if (this.isRendered) {
				this.$data._chart.destroy()
			}
			API.get(this.formUrl())
				.then(res => {
					this.dataset = res.data
					this.$emit(this.dataset.datasets.length === 0 ? 'noData' : 'yesData')
					this.$emit('finished')
					if (!this.subcat) {
						this.$emit('updateSubcats', res.data.labels)
					}
				})
		},
		formUrl () {
			let url = `ecommerce/sales-statistics/categories?start=${this.date.split('#')[0]}&end=${this.date.split('#')[1]}`
			url += `&categories=${this.subcat || this.categories}`
			url += `&salesChannel=${this.salesChannel}`
			url += `&orderDirection=${this.sort}`
			this.orderField ? url += `&orderField=${this.orderField}` : ''
			this.companies ? url += `&companyIDs=${this.companies.id}` : ''
			return url
		}
	},
	mounted () {
		API.get(this.formUrl())
			.then(res => {
				this.dataset = res.data
				if (this.dataset.datasets.length === 0) {
					this.$emit('noData')
				}
				this.isRendered = true
				this.$emit('finished')
			})
	},
	watch: {
		companies () {
			this.getData()
		},
		dataset () {
			this.renderChart(this.dataset, this.options)
		},
		group () {
			this.getData()
		},
		date () {
			this.getData()
		},
		categories () {
			this.getData()
		},
		salesChannel () {
			this.getData()
		},
		subcat () {
			this.getData()
		},
		orderField () {
			this.getData()
		},
		sort () {
			this.getData()
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/tools/Charts/CategorieStatsChart.js